// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-3a6a8d58]{font-family:\"Quicksand\",\"Source Sans Pro\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif;display:block;font-weight:300;font-size:100px;color:#35495e;letter-spacing:1px}.done[data-v-3a6a8d58]{text-decoration:line-through}h1[data-v-3a6a8d58],h2[data-v-3a6a8d58]{font-size:2rem;font-weight:500;margin-top:30px;color:#444;padding:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
